module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Stick.22ae87ad.png";